const BASE = process.env.REACT_APP_API_URL || '/api';

async function request(path, options = {}) {
  const res = await fetch(`${BASE}${path}`, {
    headers: { 'Content-Type': 'application/json', ...options.headers },
    ...options
  });
  const data = await res.json();
  if (!data.success) throw new Error(data.message || 'Request failed');
  return data.data ?? data;
}

export const getRoles = () => request('/roles');
export const getRole = (id) => request(`/roles/${id}`);
export const createRole = (body) => request('/roles', { method: 'POST', body: JSON.stringify(body) });
export const updateRole = (id, body) => request(`/roles/${id}`, { method: 'PUT', body: JSON.stringify(body) });
export const deleteRole = (id) => request(`/roles/${id}`, { method: 'DELETE' });

export const getRoleUsers = (id) => request(`/roles/${id}/users`);
export const assignUser = (roleId, userId) => request(`/roles/${roleId}/users`, { method: 'POST', body: JSON.stringify({ user_id: userId }) });
export const removeUser = (roleId, userId) => request(`/roles/${roleId}/users/${userId}`, { method: 'DELETE' });

export const getUsers = () => request('/users');

export const MODULES = [
  { key: 'dashboard',      label: 'Dashboard' },
  { key: 'clients',        label: 'All Clients' },
  { key: 'leads',          label: 'Add New Lead' },
  { key: 'quick_log',      label: 'Quick Log' },
  { key: 'fp_review',      label: 'FP Review' },
  { key: 'pipeline',       label: 'Stage & Checklist' },
  { key: 'disclosure',     label: 'Disclosures' },
  { key: 'tasks',          label: 'Tasks' },
  { key: 'approval_queue', label: 'Approval Queue' },
  { key: 'document_vault', label: 'Document Vault' },
  { key: 'ai_assist',      label: 'AI Assist' },
  { key: 'role_management',label: 'Role Management' },
  { key: 'user_management',label: 'User Management' },
];

export const ACTIONS = ['view', 'create', 'edit', 'delete', 'approve'];
